import React from 'react'
import config from '../index'
import translate from 'core/translate'
import CustomListHeader, { ICustomListHeaderProps } from '../../../__header/customList__header'
import Button from 'blocks.simple/button/button'
import EditableText from 'blocks.simple/editableText/editableText'
import CatalogSelectContent from 'blocks.app/catalog/_select/_content/catalog_select_content'
import { api } from 'core/api/ConnectionManager'
import validator from 'validator'
import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import store from 'core/store'
import listStyles, { mediaPreviewItemStyles } from '../../../__content/customList__content.jcss'

interface Item {
    __view: { selected: Item }
    topImageSource: {
        __view: {
            selected: Item
        }
    }
}

export default {
    ...config,
    category: 'recommended',
    type: 'askona',
    getItemModel: (dataItem: Item, getSelected: (item: Item) => any) => {
        const item = { ...dataItem }

        if (item.topImageSource && !item.topImageSource.__view) {
            item.topImageSource.__view = {
                selected: getSelected(item),
            }
        }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    headerFilters: (p_: ICustomListHeaderProps) => (
        <CustomListHeader
            {...p_}
            onAdd={() => {
                if (!p_.fakeLine) {
                    p_.onAddFakeLine({ href: '', topImageSource: null })
                } else {
                    p_.onAnimate(true)
                    setTimeout(() => {
                        p_.onAnimate(false)
                    }, 1000)
                }
            }}
            title={translate('recommended')}
            type={p_.type}
            onDelete={() => {
                const id = p_.selectedItems.map((selectedItem) => selectedItem.id)
                if (id.length > 0) {
                    api.send('askonaDeleteCatalogItem', { id })
                }
                if (p_.fakeLine) {
                    p_.onAddFakeLine(null)
                }
            }}
        />
    ),
    fields: () => [
        { id: 'topImageSource', name: translate('image') },
        { id: 'href', name: translate('url') },
    ],
    init(callback: any) {
        // @ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    list: {
        href: (
            p_: { id: number; href: string },
            active: boolean,
            listProps: {
                fakeLine: {
                    href: string
                    topImageSource: {
                        id: number
                    }
                }
                onAddFakeLine: (value?: {}) => void
                template: any
                catalogId: string
            }
        ) => (
            <div className={cn(grid.fullWidth, { [grid.row]: !p_.id })}>
                <div className={cn({ [grid.fullWidth]: p_.id, [grid.space]: !p_.id, [grid.pl_mini]: p_.id })}>
                    <EditableText
                        id={p_.id}
                        text={p_.href}
                        onChange={(href: string) => {
                            listProps.onAddFakeLine({ ...listProps.fakeLine, href })
                        }}
                        onUpdate={(href, cb) => {
                            if (validator.isURL(href, { protocols: ['http', 'https'], require_protocol: true })) {
                                api.send('askonaUpdateCatalogItem', {
                                    href,
                                    id: p_.id,
                                    catalogId: listProps.catalogId,
                                    category: listProps.template.category,
                                }).then(cb)
                            } else {
                                store.dispatch(emitError('linkFormatError'))
                            }
                        }}
                    />
                </div>
                {!p_.id && (
                    <Button
                        className={cn(grid.ml_micro, grid.mr_mini)}
                        indentSize={'mini'}
                        textSize={'mini'}
                        rounded={'full_normal'}
                        onClick={function () {
                            listProps.onAddFakeLine()
                        }}
                    >
                        {translate('cancel')}
                    </Button>
                )}
                {!p_.id && (
                    <Button
                        mod={'fill'}
                        indentSize={'mini'}
                        textSize={'mini'}
                        rounded={'full_normal'}
                        onClick={function () {
                            if (
                                validator.isURL(listProps.fakeLine.href, {
                                    protocols: ['http', 'https'],
                                    require_protocol: true,
                                })
                            ) {
                                api.send('askonaCreateCatalogItem', {
                                    catalogId: listProps.catalogId,
                                    category: listProps.template.category,
                                    href: listProps.fakeLine.href,
                                    topImageSourceId: listProps.fakeLine.topImageSource.id,
                                })
                            } else {
                                store.dispatch(emitError('linkFormatError'))
                            }
                        }}
                        disabled={!listProps.fakeLine.topImageSource || !listProps.fakeLine.href}
                    >
                        {translate('save')}
                    </Button>
                )}
            </div>
        ),
        topImageSource: (
            p_: { id: number; topImageSource: object },
            active: boolean,
            listProps: {
                catalogId: string
                template: { category: string }
                onAddFakeLine: (value?: {}) => void
                fakeLine: {
                    topImageSource: {
                        id: number
                    }
                }
            }
        ) => (
            <div className={cn(grid.fullWidth, grid.colCenter)}>
                <div className={p_.topImageSource ? listStyles.mediaPreviewFilled : undefined}>
                    <CatalogSelectContent
                        type={'image'}
                        isHideSidebar
                        selectedInfo={p_.topImageSource}
                        selectedItemStyles={p_.topImageSource ? mediaPreviewItemStyles : undefined}
                        onSelect={(selectedMedia: { id: number }) => {
                            if (p_.id) {
                                api.send('askonaUpdateCatalogItem', {
                                    id: p_.id,
                                    catalogId: listProps.catalogId,
                                    category: listProps.template.category,
                                    topImageSourceId: selectedMedia.id,
                                })
                            } else {
                                listProps.onAddFakeLine({ ...listProps.fakeLine, topImageSource: selectedMedia })
                            }
                        }}
                    />
                </div>
            </div>
        ),
    },
}
